export default {"src":"/_next/static/media/other.ae863828.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};